import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import "../../assets/css/layout/admin/Adminlayout.css";
/* import { Outlet } from "react-router-dom"; */

const Adminlayout = ({children}) => {
  return (
    <div className="adl-student-layout">
      {/* Sidebar - Fixed position */}
      <Sidebar />

      {/* Header - Fixed position */}
      <Header />

      {/* Main Content Area */}
      <main className="adl-Admin-main">
        <div className="adl-Admin-content">
          {/* Yahan dashboard ya other pages render honge */}
          {/* <Outlet /> */}
          {children}
        </div>
      </main>
    </div>
  );
};

export default Adminlayout;